















import { AdminSiteManagementDefaultDevice } from '@/constants/admin-site-management'
import { AdminSiteManagementDeviceTypes } from '@/constants/admin-site-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
    isSavingData: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isInitialLoading: true,
    }
  },

  computed: {},

  mounted: async function(): Promise<void> {
    this.isInitialLoading = false
    this.emitValidStatus()
  },

  methods: {
    isValid() {
      return true
    },
    emitValidStatus() {
      console.log('emitValidStatus(): ' + this.isValid())
      return this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.isValid(),
      })
    },
  },
}
